import { cn } from '@restworld/utils-common';
export const EmployerPageContentWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('pb-20 px-4 lg:px-10 xl:px-20 max-w-screen-xl mx-auto', className)} {...props} />
);
